import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex } from 'reflexbox';

import { TitleContainer, SmallButton, SettingsLabel } from '../components/BranchComponents';
import { DeliveryCheckbox } from './DeliveryComponents';
import NewTimeslotCreator from './NewTimeslotCreator';

const DeliveryTimeslotsList = ({ timeslots, onChange, disabled }) => {
  const [isCreatingNewTimeslot, setIsCreatingNewTimeslot] = useState(false);

  const toggleIsCreatingNewTimeslot = () =>
    setIsCreatingNewTimeslot(prevIsCreatingNewTimeslot => !prevIsCreatingNewTimeslot);

  const createTimeslotChangeHandler = timeslot => checked => {
    if (!(checked || window.confirm(`Do you want to delete this timeslot? ${timeslot.start}-${timeslot.end}`))) {
      return;
    }

    onChange(timeslot, checked);
  };
  
  const addTimeslotHandler = timeslot => {
    onChange(timeslot, true);
    toggleIsCreatingNewTimeslot();
  };

  return (
    <>
      <SettingsLabel>
        <TitleContainer>Delivery time slots</TitleContainer>
        <SmallButton disabled={disabled} onClick={toggleIsCreatingNewTimeslot}>
          {isCreatingNewTimeslot ? 'Cancel' : 'Add slot'}
        </SmallButton>
      </SettingsLabel>
      <FlexWrap>
        {timeslots &&
          timeslots.map(timeslot => (
            <DeliveryCheckbox
              disabled={disabled}
              checked
              key={timeslot.start}
              onChange={createTimeslotChangeHandler(timeslot)}
            >
              {`${timeslot.start}-${timeslot.end}`}
            </DeliveryCheckbox>
          ))}
        {isCreatingNewTimeslot && (
          <NewTimeslotCreator
            onSubmit={addTimeslotHandler}
            onCancel={toggleIsCreatingNewTimeslot}
          />
        )}
      </FlexWrap>
    </>
  );
};

const FlexWrap = styled(Flex)`
  flex-wrap: wrap;
`;

export default DeliveryTimeslotsList;
